/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import eq from 'ember-truth-helpers/helpers/eq';
import JesHistoryTable from 'parog-web/components/jes-history-table';
import ValueWithUnit from 'parog-web/components/value-with-unit';
import PageContainer from 'ui-kit/components/page-container';
interface Signature {
  Args: {
    headerHidden?: unknown;
    patient?: unknown;
  };
}

const MyComponent: TOC<Signature> = <template>
  <PageContainer
    @title='Historique des questionnaires médicaux'
    {{! @glint-expect-error }}
    @headerHidden={{@headerHidden}}
  >
    <:content>
      {{! @glint-expect-error }}
      <JesHistoryTable class='unstackable striped' @patient={{@patient}}>
        <:columns as |Column|>

          {{! @glint-expect-error }}
          {{#if (eq @patient.followUpReasonId 'mental-depression')}}
            <Column
              @modelName='phq-nine-declared-journal-event'
              @feature='scale-surveys'
              @component='phq-nine-edition-form'
            >
              <:label>PHQ-9</:label>
              <:value as |je|>
                <ValueWithUnit @value={{je.total}} @unit='/27' />
              </:value>
            </Column>

            <Column
              @modelName='bdi-ii-declared-journal-event'
              @feature='scale-surveys'
              @component='bdi-ii-edition-form'
            >
              <:label>BDI-II</:label>
              <:value as |je|>
                <ValueWithUnit @value={{je.total}} @unit='/63' />
              </:value>
            </Column>
          {{else}}
            <Column
              @modelName='fast-declared-journal-event'
              @feature='scale-surveys'
              @component='fast-edition-form'
            >
              <:label>FAST</:label>
              <:value as |je|>
                <ValueWithUnit @value={{je.total}} @unit='/72' />
              </:value>
            </Column>

            <Column
              @modelName='qids-declared-journal-event'
              @feature='scale-surveys'
              @component='qids-edition-form'
            >
              <:label>QIDS</:label>
              <:value as |je|>
                <ValueWithUnit @value={{je.total}} @unit='/27' />
              </:value>
            </Column>

            <Column
              @modelName='ymrs-declared-journal-event'
              @feature='scale-surveys'
              @component='ymrs-edition-form'
            >
              <:label>YMRS</:label>
              <:value as |je|>
                <ValueWithUnit @value={{je.total}} @unit='/66' />
              </:value>
            </Column>
          {{/if}}
        </:columns>

        <:noData>Aucun questionnaire d'échelle n'a été remplis pour ce patient.</:noData>
      </JesHistoryTable>
    </:content>
  </PageContainer>
</template>;
export default MyComponent;
